import React from 'react';
import {race} from "../../../models/race";
import DateService from "../../../service/DateService";

export type CalendrierDetailModalProps = {
  race: race;
  close: () => void;
}

export const CalendrierDetailModal = ({race, close}: CalendrierDetailModalProps) => {
  return (
    <>
      <div className="__modal_container__ d-flex justify-content-center align-items-center">
        <div className="__modal_background__" onClick={() => close()}/>
        <div className="__modal_box__ __front_box__ w80 max-w700px">
          <i className="float-end cursor-pointer fa-solid fa-circle-xmark text-info" onClick={() => close()}/>
          <div>
            <h2 className="__front_info_title__ m-0 break-word">{race.label}</h2>
            <hr className="w75 ms-auto me-auto mt-3 mb-2"/>
            <p className="m-0 text-center text-gray">
              {DateService.toLocaleString(race.rideDate, {weekday: 'long', day: '2-digit', month: 'short', year: 'numeric'})}
            </p>
          </div>

          <div className="mt-3">
            {race.description && (
              <p className="text-capitalize break-word">
                {race.description}
              </p>
            )}
            {race.link && (
              <p>
                <a href={race.link} target="_blank" rel="noreferrer"><i className="fa-solid fa-link"/> {race.link}</a>
              </p>
            )}
            <div className="row">
              <div className="col-6 text-start">
                {race.ranking ? (<span><i className="fa-solid fa-flag-checkered me-1"/>Course</span>) : (<span><i className="fa-solid fa-person-biking me-1"/>Randonnée</span>)}
              </div>
              <div className="col-6 text-end">
                {(race.paid || race.subsidized) && (
                  <>
                    {race.paid && (
                      <><i className="fa-solid fa-money-bill-wave" title="Payée par le club"/> Payée</>
                    )}
                    {race.subsidized && (
                      <><i className="fa-solid fa-hand-holding-dollar" title="Subventionnée par le club"/> Subventionnée</>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
